import { useContext, useState } from 'react';
import { RestauInfoContext } from '../home/RestauInfoContext';
import Config from '../config/Config';
import axios from 'axios';

const getCallRecordingDataFromDb = async (payload) => {
    const token = await window.customerApp.auth().currentUser.getIdToken();
    var config = {
        headers: {
            token: token,
            'Content-Type': 'application/json',
        },
    };

    //function to fetch the Phone Settings from databasse
    return await axios.post(
        Config.fetchCallRecordingAndTrainingDetails,
        payload,
        config
    );
};

const getOrderSummSimulationResultsFromDb = async (payload) => {
    const token = await window.customerApp.auth().currentUser.getIdToken();
    var config = {
        headers: {
            token: token,
            'Content-Type': 'application/json',
        },
    };

    //function to fetch the Phone Settings from databasse
    return await axios.post(
        Config.getOrderSummarySimulationResults,
        payload,
        config
    );
};

const getSimulationJobDetailedStats = async (payload) => {
    const token = await window.customerApp.auth().currentUser.getIdToken();
    var config = {
        headers: {
            token: token,
            'Content-Type': 'application/json',
        },
    };

    //function to fetch the Phone Settings from databasse
    return await axios.post(
        Config.getOrderSummarySimulationDetailedStats,
        payload,
        config
    );
};

const saveCallRecordingDataToDb = async (payload) => {
    const token = await window.customerApp.auth().currentUser.getIdToken();
    var config = {
        headers: {
            token: token,
            'Content-Type': 'application/json',
        },
    };
    //function to fetch the Phone Settings from databasse
    return await axios.post(
        Config.saveCallRecordingAndTrainingData,
        payload,
        config
    );
};

const saveAndTriggerSimulationJobToDb = async (payload) => {
    const token = await window.customerApp.auth().currentUser.getIdToken();
    var config = {
        headers: {
            token: token,
            'Content-Type': 'application/json',
        },
    };

    //function to fetch the Phone Settings from databasse
    return await axios.post(
        Config.saveAndTriggerSimulationJob,
        payload,
        config
    );
};

const callAPIToGetOrUpdateDataInDb = async (payload, apiMethod) => {
    const token = await window.customerApp.auth().currentUser.getIdToken();
    var config = {
        headers: {
            token: token,
            'Content-Type': 'application/json',
        },
    };

    //axios call to the API based on the corresponding api method in config
    return await axios.post(Config[apiMethod], payload, config);
};

const useAiTrainingData = () => {
    const { restauHook } = useContext(RestauInfoContext);
    const [callRecAndTrainingData, setCallRecAndTrainingData] = useState([]);
    const [simulationJobResults, setSimulationJobResults] = useState([]);
    const [simulationJobDetailedStats, setSimulationJobDetailedStats] =
        useState([]);
    const [selectedSimJob, setSelectedSimJob] = useState({});
    const [loading, setLoading] = useState(false);
    const [simResultsLoading, setSimResultsLoading] = useState(false);
    const [simDetailedStatsLoading, setSimDetailedStatsLoading] =
        useState(false);

    const statusListItems = [
        { id: 1, label: 'New', value: 'new' },
        { id: 2, label: 'In Progress', value: 'inProgress' },
        { id: 3, label: 'Completed', value: 'completed' },
        { id: 4, label: 'Not Order Related', value: 'notOrderRelated' },
        { id: 5, label: 'Multi-Lingual', value: 'multiLingual' },
        { id: 6, label: 'VoiceMail', value: 'voiceMail' },
    ];
    const restauId = restauHook.restauId;
    const restauTimeZone = restauHook.restauTimeZone;

    const fetchAllVersionsOfSummarizationPrompt = async () => {
        //debugger;
        let reqBody = {
            restauId: restauId,
        };
        //debugger;
        let response = await callAPIToGetOrUpdateDataInDb(
            reqBody,
            'getVersionsForOrderSummPrompt'
        ).catch((err) => {
            console.log(err);
            throw new Error(err.toString());
        });

        if (response && response.status === 200) {
            return response.data.data;
            // if (response.data.data.length > 0) {
            //     setAllOrderSummPromptVersions([
            //         ...response.data.data.map((val, index) => {
            //             return {
            //                 id: val.id,
            //                 //docId: val.docId,
            //                 label:
            //                     (index === 0 ? 'latest (' : '') +
            //                     val.majorVersion +
            //                     '.' +
            //                     val.minorVersion +
            //                     (index === 0 ? ')' : ''),
            //                 value: val.majorVersion + '.' + val.minorVersion,
            //             };
            //         }),
            //     ]);
            // } else {
            //     setAllOrderSummPromptVersions([
            //         {
            //             id: 'new',
            //             //docId: undefined,
            //             label: 'latest (1.0)',
            //             value: '1.0',
            //         },
            //     ]);
            // }
        } else {
            return null;
        }
    };

    const getOrderSummarizationPromptForVersion = async (promptVersionId) => {
        let reqBody = {
            restauId: restauId,
            promptVersionId: promptVersionId,
            // majorVersion: majorVersion,
            // minorVersion: minorVersion,
        };
        //debugger;
        let response = await callAPIToGetOrUpdateDataInDb(
            reqBody,
            'getOrderSummarizationPrompt'
        ).catch((err) => {
            console.log(err);
            throw new Error(err.toString());
        });

        if (response && response.status === 200) {
            return response.data.data;
        }
    };

    const saveCallSummarizationPrompt = async (
        prompt,
        curVersion,
        curVersionId,
        saveAsNewVersion,
        saveAsVersion
    ) => {
        //debugger;
        let reqBody = {};

        //latest will always be the first one
        //let version = allOrderSummPromptVersions[0].value;
        let minorVersion = parseInt(curVersion.split('.')[1]);
        let majorVersion = parseInt(curVersion.split('.')[0]);

        if (saveAsNewVersion) {
            if (saveAsVersion === 'saveAsNewMinor') {
                minorVersion = minorVersion + 1;
            } else {
                majorVersion = majorVersion + 1;
                minorVersion = 1;
            }
        } else {
            if (curVersionId !== 'new') reqBody.id = curVersionId;
        }

        if (minorVersion === undefined || majorVersion === undefined) {
            alert('Failed to parse the version details of the prompt.');
            return;
        }

        reqBody = {
            ...reqBody,
            restauId: restauId,
            promptToSave: prompt,
            majorVersion: majorVersion,
            minorVersion: minorVersion,
            //saveAsNewVersion: saveAsNewVersion,
        };
        //debugger;
        let response = await callAPIToGetOrUpdateDataInDb(
            reqBody,
            'saveOrderSummarizationPrompt'
        ).catch((err) => {
            console.log(err);
            throw new Error(err.toString());
        });

        if (response && response.status === 200) {
            return true;
        }
    };

    const fetchCallRecordingData = async (filterData) => {
        let reqBody = {
            restauId: restauId,
            startTimeStamp: filterData.fromTimeStamp,
            endTimeStamp: filterData.toTimeStamp,
            status: filterData.status,
        };
        //debugger;
        let response = await getCallRecordingDataFromDb(reqBody).catch(
            (err) => {
                console.log(err);
                throw new Error(err.toString());
            }
        );

        if (response && response.status === 200) {
            setCallRecAndTrainingData(
                response.data.data.map((x) => {
                    return { ...x, edited: false, saveInProgress: false };
                })
            );
        }
    };

    const saveCallRecordingData = async (
        recordingId,
        orderSummaryItems,
        updatedTranscription,
        status
    ) => {
        const token = await window.customerApp.auth().currentUser.getIdToken();
        var config = {
            headers: {
                token: token,
                'Content-Type': 'application/json',
            },
        };

        let reqBody = {
            restauId: restauId,
            status: status,
            recordingId: recordingId,
            orderSummaryItems: orderSummaryItems,
            updatedTranscription: updatedTranscription,
        };

        //function to fetch the Phone Settings from databasse
        let response = await saveCallRecordingDataToDb(reqBody, config).catch(
            (err) => {
                console.log(err);
                throw new Error(err.toString());
            }
        );
        if (response && response.status === 200) {
            console.log('CallRecordingAndTraining Details saved successfully');
            return true;
        } else {
            console.log('Failed to save CallRecordingAndTraining Details');
            return false;
        }
    };

    const fetchSimulationJobResults = async () => {
        if (!restauId) return;

        let reqBody = {
            restauId: restauId,
        };
        //debugger;
        let response = await getOrderSummSimulationResultsFromDb(reqBody).catch(
            (err) => {
                console.log(err);
                throw new Error(err.toString());
            }
        );

        if (response && response.status === 200) {
            setSimulationJobResults(
                response.data.data.map((x) => {
                    return {
                        ...x,
                        id: x.jobId,
                        // status:
                        //     x.numberOfRecordings === x.processedRecordings
                        //         ? 'Completed'
                        //         : 'In Progress',
                    };
                })
            );
        }
    };

    const fetchSumilationJobDetailedStats = async (jobId) => {
        if (!restauId) return;

        //debugger;
        setSelectedSimJob((prevVal) =>
            simulationJobResults.find((x) => x.jobId === jobId)
        );

        let reqBody = {
            restauId: restauId,
            jobId: jobId,
        };
        //debugger;
        let response = await getSimulationJobDetailedStats(reqBody).catch(
            (err) => {
                console.log(err);
                throw new Error(err.toString());
            }
        );

        if (response && response.status === 200) {
            setSimulationJobDetailedStats(
                response.data.data.map((x) => {
                    return {
                        ...x,
                        id: x.recordingSid,
                    };
                })
            );
        }
    };

    const saveAndTriggerSimulationJob = async (
        jobId,
        promptVersionIdToUse,
        recordingsToSimulate
    ) => {
        //debugger;
        //saveAndTriggerSimulationJob
        let reqBody = {
            restauId: restauId,
            jobId: jobId,
            promptVersionIdToUse: promptVersionIdToUse,
            recordings: recordingsToSimulate,
        };
        //debugger;
        let response = await saveAndTriggerSimulationJobToDb(reqBody).catch(
            (err) => {
                console.log(err);
                throw new Error(err.toString());
            }
        );

        console.log(response);

        // if (response && response.status === 200) {
        // }
    };

    const resetCallRecordingData = async () => {
        setCallRecAndTrainingData([]);
    };

    const reloadCallRecordingData = async (filterData) => {
        fetchCallRecordingData(filterData);
    };

    return {
        statusListItems,
        fetchCallRecordingData,
        saveCallRecordingData,
        callRecAndTrainingData,
        setCallRecAndTrainingData,
        restauId,
        restauTimeZone,
        loading,
        setLoading,
        resetCallRecordingData,
        reloadCallRecordingData,
        simResultsLoading,
        setSimResultsLoading,
        simulationJobResults,
        fetchSimulationJobResults,
        simulationJobDetailedStats,
        simDetailedStatsLoading,
        setSimDetailedStatsLoading,
        fetchSumilationJobDetailedStats,
        selectedSimJob,
        saveAndTriggerSimulationJob,
        setSelectedSimJob,
        fetchAllVersionsOfSummarizationPrompt,
        //allOrderSummPromptVersions,
        saveCallSummarizationPrompt,
        getOrderSummarizationPromptForVersion,
    };
};

export default useAiTrainingData;
